import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

/**
 * Display a radio button list inline.
 *
 * Examples :
 *
 *   <app-radios-input [title]="'Ma question'" [control]="{ fg: myForm, fcn: 'myControlName' }"></app-radios-input>
 *
 *   <app-radios-input
 *       [title]="'Ma question'"
 *       [control]="{ fg: myForm, fcn: 'myControlName' }">
 *       [nb]="3"
 *       [labels]="['Rouge', 'Vert' , 'Bleu', 'Ne sais pas']">
 *       [values]="['red'  , 'green', 'blue', null         ]">
 *   </app-radios-input>
 */

@Component({
  selector: 'app-radios-input',
  templateUrl: './radios-input.component.html',
  styleUrls: ['./radios-input.component.scss'],
  imports: [ReactiveFormsModule],
})
export class RadioInputComponent implements OnInit {
  numbers: number[] = [];

  // *********************************************************************************************
  // * NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG *
  // * NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG *
  // *********************************************************************************************

  @Input() nb: number = 2;

  @Input() title!: string;

  @Input() control!: {
    fg: FormGroup; // Form group
    fcn: string; // Form control name
  };

  @Input() labels: string[] = ['Oui', 'Non', 'Ne sait pas'];

  @Input() values: any[] = [true, false, null];

  // *********************************************************************************************
  // On init

  ngOnInit(): void {
    this.numbers = Array(this.nb)
      .fill(undefined)
      .map((_x, i) => i); // [0, 1, 2, 3, 4]
  }
}
